import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import { customStyle, quarterList } from 'helper';
import InputMask from 'react-input-mask';
import Alert from 'react-s-alert';
import PropTypes from 'prop-types';
import Select from 'react-select';
import useFormValidator from 'useFormValidator';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import * as actions from '../../../action';
import * as c from '../../../constant';

function SubdivisionModal({
  createTransferApplication,
  getApplicationsList,
  history,
  searchTdnSubdivision,
  transactionCode,
  getTaxEffectivityPeriods,
  taxEffectivityPeriod,
  showData,
  isLoading,
}) {

  const setModal = useContext(ModalContext);

  const [buildingListData, setBuildingDataListData] = React.useState({
    building_application_id: [],
  });

  const [form, setForm] = useState({
    tax_effectivity_quarter: "",
    tax_effectivity_year: "",
    number_of_parcels: "",
    for_improvement: 0,
  });

  const validateForm = useFormValidator(form, {
    tax_effectivity_quarter: "required",
    tax_effectivity_year: "required",
    number_of_parcels: "required"
  });

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(form).join(',')]);

  const handleOnSubmit = (e) => {
    e.preventDefault();

    if (!validateForm.response.is_passed) {
      return false;
    }

    const newSetOfForm = (buildingListData.building_application_id || []).map(item => Number(item.building_application_id));

    const args = {
      ...form,
      rptax_transaction_code_id: transactionCode,
      building_application_id: newSetOfForm
    };

    createTransferApplication(args, () => {
      setModal({ isOpen: false });
      getApplicationsList({}, ({ data }) => {
        history.push(`/rpt/building/applications/${_.get(data, '0.id')}`);
        showData(_.get(data, '0.id'));
      });
    });

    return false;
  };

  const findTdn = (e) => {
    e.preventDefault();
    if (form.for_improvement === 0) {
      searchTdnSubdivision(form.tdn, transactionCode, 0, (buildingData) => {
        if (!_.isEmpty(buildingData)) {
          Alert.success("Application Found.")
          getTaxEffectivityPeriods(
            buildingData.data.id,
            {
              rptax_transaction_code_id: transactionCode,
            }
          );
          setForm({
            ...form,
            tdn: '',
            for_improvement: 0
          });
          if (!_.isEmpty(buildingData?.data?.attributes?.change_batch)) {
            getApplicationsList(
              { change_batch: buildingData?.data?.attributes?.change_batch },
              ({ data }) => {
                const consiData = data.map((item, i) => {
                  return {
                    id: i + 1,
                    building_application_id: item.id,
                    arp_no: item.attributes.arp_no,
                    pin: item.attributes.pin,
                    previous_owner: item.attributes.rptax_owner_id,
                    address: item.attributes.property_address,
                    assessed: item.attributes.appraised_assessed_by,
                    barangay_id: item.attributes.property_barangay_id,
                    total_appraisal_area: item.attributes.total_appraisal_area,
                    total_remaining_area: item.attributes.total_floor_area,
                    changed_code_id: item.attributes.changed_code_id,
                  };
                });
                setBuildingDataListData({
                  building_application_id: (
                    buildingListData.building_application_id || []
                  ).concat(consiData),
                });
              }
            );
          }
        } else {
          Alert.error("No Application Found.")
        }
        if (
          !_.isEmpty(
            buildingListData.building_application_id.find(
              (item) =>
                _.get(item, 'building_application_id') === buildingData.data.id
            )
          )
        ) {
          Alert.warning(`${buildingData.data.attributes.arp_no} already added.`);
        }
        if (
          _.isEmpty(
            buildingListData.building_application_id.find(
              (item) =>
                _.get(item, 'building_application_id') === buildingData.data.id
            )
          ) &&
          _.isEmpty(buildingData?.data?.attributes?.change_batch)
        ) {
          setBuildingDataListData({
            building_application_id: (
              buildingListData.building_application_id || []
            ).concat([
              {
                id:
                  (_.get(
                    buildingListData,
                    `building_application_id.${buildingListData.building_application_id.length - 1
                    }.id`
                  ) || 0) + 1,
                building_application_id: buildingData.data.id,
                arp_no: buildingData.data.attributes.arp_no,
                pin: buildingData.data.attributes.pin,
                previous_owner: buildingData.data.attributes.rptax_owner_id,
                address: buildingData.data.attributes.property_address,
                assessed: buildingData.data.attributes.appraised_assessed_by,
                barangay_id: buildingData.data.attributes.property_barangay_id,
                total_appraisal_area:
                  buildingData.data.attributes.total_appraisal_area,
                total_remaining_area:
                  buildingData.data.attributes.total_floor_area,
                changed_code_id: buildingData.data.attributes.changed_code_id,
              },
            ]),
          });
        }
      });
    } else if (form.for_improvement === 1) {
      searchTdnSubdivision(form.tdn, transactionCode, 1, (buildingData) => {
        if (!_.isEmpty(buildingData)) {
          Alert.success("Application Found.")
          setForm({
            ...form,
            tdn: '',
            for_improvement: 0
          });
          getTaxEffectivityPeriods(
            buildingData.data.id,
            {
              rptax_transaction_code_id: transactionCode,
            }
          );
          if (!_.isEmpty(buildingData?.data?.attributes?.change_batch)) {
            getApplicationsList(
              { change_batch: buildingData?.data?.attributes?.change_batch },
              ({ data }) => {
                const consiData = data.map((item, i) => {
                  return {
                    id: i + 1,
                    building_application_id: item.id,
                    arp_no: item.attributes.arp_no,
                    pin: item.attributes.pin,
                    previous_owner: item.attributes.rptax_owner_id,
                    address: item.attributes.property_address,
                    assessed: item.attributes.appraised_assessed_by,
                    barangay_id: item.attributes.property_barangay_id,
                    total_appraisal_area: item.attributes.total_appraisal_area,
                    total_floor_area: item.attributes.total_floor_area,
                    total_remaining_area: item.attributes.total_remaining_area,
                    changed_code_id: item.attributes.changed_code_id,
                  };
                });
                setBuildingDataListData({
                  building_application_id: (
                    buildingListData.building_application_id || []
                  ).concat(consiData),
                });
              }
            );
          }
        } else {
          Alert.error("No Application Found.")
        }
        if (
          !_.isEmpty(
            buildingListData.building_application_id.find(
              (item) =>
                _.get(item, 'building_application_id') === buildingData.data.id
            )
          )
        ) {
          Alert.warning(`${buildingData.data.attributes.arp_no} already added.`);
        }
        if (
          _.isEmpty(
            buildingListData.building_application_id.find(
              (item) =>
                _.get(item, 'building_application_id') === buildingData.data.id
            )
          ) &&
          _.isEmpty(buildingData?.data?.attributes?.change_batch)
        ) {
          setBuildingDataListData({
            building_application_id: (
              buildingListData.building_application_id || []
            ).concat([
              {
                id:
                  (_.get(
                    buildingListData,
                    `building_application_id.${buildingListData.building_application_id.length - 1
                    }.id`
                  ) || 0) + 1,
                building_application_id: buildingData.data.id,
                arp_no: buildingData.data.attributes.arp_no,
                pin: buildingData.data.attributes.pin,
                previous_owner: buildingData.data.attributes.rptax_owner_id,
                address: buildingData.data.attributes.property_address,
                assessed: buildingData.data.attributes.appraised_assessed_by,
                barangay_id: buildingData.data.attributes.property_barangay_id,
                total_appraisal_area:
                  buildingData.data.attributes.total_appraisal_area,
                total_remaining_area:
                  buildingData.data.attributes.total_floor_area,
                changed_code_id: buildingData.data.attributes.changed_code_id,
              },
            ]),
          });
        }
      });
    }
  };

  const handleSelected = (key) => (e) => {
    setForm({
      ...form,
      ...(key === 'tax_effectivity_year'
        ? { tax_effectivity_quarter: '' }
        : {}),
      [key]: e.value,
    });
  };

  const handleRemoveItem = (item) => () => {
    const newItem = {
      building_application_id: (buildingListData.building_application_id || []).filter(
        (x) => x.id !== item.id
      ),
    };
    setBuildingDataListData(newItem);
  };

  const yearOptionsSDCD =
    taxEffectivityPeriod?.map((i) => {
      return {
        label: i.year,
        value: i.year,
      };
    });

  const quarterOptionsSDCD =
    taxEffectivityPeriod
      .find((i) => +i.year === +_.get(form, 'tax_effectivity_year'))
      ?.quarter?.map((quarter) => ({
        label: quarterList.find((option) => +option.value === +quarter)
          .label,
        value: quarter,
      }));

  const onChange = (e) => {
    const isChecked = e.target.checked ? 1 : 0;
    return setForm({
      ...form,
      [e.target.name]:
        e.target.type === 'checkbox' ? isChecked : e.target.value,
    });
  };

  const onChangeCheckbox = (e) => {
    const for_improvement = +_.get(form, "for_improvement", 0) ? 0 : 1;

    let newValue = e.target.value
    if (e.target.name === "for_improvement") {
      newValue = for_improvement
    }

    setForm({
      ...form,
      [e.target.name]: newValue,
      land_application_id: "",
      building_application_id: "",
      rptax_building_application_id: "",
      td_owner: "",
      td_oct: "",
      td_oct_date: "",
      td_lot_no: "",
      td_block: "",
      td_area: "",
      property_barangay_id: "",
      property_district_id: "",
      property_street: ""
    });
  };

  return (
    <Modal.Body>
      <div className="row">
        <div className="col-12 form-group">
          <label className="m-0 text-color font-weight-bold">
            Subdivision
          </label>
        </div>
        <div className="col-6 form-group">
          <label htmlFor="last_name" className="form-label mb-0">TDN/ARP No.
          </label>
          <div
            className="input-group mb-3 col-12 mt-2"
            style={{ marginLeft: -15 }}
          >
            <InputMask
              className="form-control"
              mask="aa-99999-99999"
              alwaysShowMask
              type="text"
              name="tdn"
              onChange={onChange}
              value={_.get(form, 'tdn')}
              disabled={(form.for_improvement === 0 && buildingListData.length === 1)}
            />
            <div className="input-group-append">
              <button
                disabled={
                  _.get(form, 'tdn') === '__-_____-_____' ||
                  _.get(form, 'tdn') === ''
                }
                type="button"
                onClick={findTdn}
                className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
              >
                <span className="icon">
                  <i className="fa fa-lg fa-search" />
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="col-6 form-group ml-auto">
          <label htmlFor="last_name" className="form-label">
            For Improvement &nbsp;
          </label>
          <input
            name="for_improvement"
            type="checkbox"
            checked={_.get(form, 'for_improvement')}
            onChange={onChangeCheckbox}
          />
        </div>
        <div className="col-12 form-group">
          <table
            className="table table-sm table-hover"
            style={{ minWidth: '250px' }}
          >
            <thead className="table-header">
              <tr>
                <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                  ARP/TDN
                </th>
                <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                  PIN
                </th>
                <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {(buildingListData.building_application_id || []).map(
                (items) =>
                (
                  <tr key={items.id}>
                    <td className="p-3">{items.arp_no}</td>
                    <td className="p-3">{items.pin}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-link"
                        onClick={handleRemoveItem(items)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Number of Parcels {validateForm.renderMessage('number_of_parcels')}
          </label>
          <input
            className="form-control"
            type="number"
            name="number_of_parcels"
            onChange={onChange}
            value={_.get(form, 'number_of_parcels')}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Total Remaining Area</label>
          <input
            className="form-control"
            type="number"
            name="total_remaining_area"
            value={buildingListData?.building_application_id?.[0]?.total_remaining_area
              ? buildingListData.building_application_id[0].total_remaining_area : 0
            }
            disabled
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Tax Effectivity Year
            {validateForm.renderMessage('tax_effectivity_year')}
          </label>
          <Select
            options={yearOptionsSDCD}
            styles={customStyle}
            placeholder="Select Year"
            value={yearOptionsSDCD?.find(
              (item) =>
                item.value === _.get(form, 'tax_effectivity_year')
            )}
            onChange={handleSelected('tax_effectivity_year')}
            isDisabled={_.isEmpty(buildingListData.building_application_id)}
          />
        </div>
        <div className="col-6 form-group">
          <label className="form-label">Tax Effectivity Quarter
            {validateForm.renderMessage('tax_effectivity_quarter')}
          </label>
          <Select
            options={quarterOptionsSDCD}
            styles={customStyle}
            placeholder="Select Quarter"
            value={quarterOptionsSDCD?.find(
              (item) =>
                item.value === _.get(form, 'tax_effectivity_quarter')
            )}
            onChange={handleSelected('tax_effectivity_quarter')}
            isDisabled={_.isEmpty(buildingListData.building_application_id)}
          />
        </div>
      </div>
      <hr className='below-hr' />
      <div className="d-flex justify-content-center">
        <button
          disabled={isLoading || !validateForm.response.is_passed}
          onClick={handleOnSubmit}
          type="button"
          className="mt-5 btn btn-primary cms-bg-color-primary cms-outline-primary"
        >
          <span className="font-weight-bold">
            {isLoading && <i className="fa fa-spin fa-spinner" />}{" "}
            Submit
          </span>
        </button>
      </div>
    </Modal.Body>
  );
}

SubdivisionModal.defaultProps = {
  transactionCode: 0
};

SubdivisionModal.propTypes = {
  transactionCode: PropTypes.number,
  createTransferApplication: PropTypes.instanceOf(Function).isRequired,
  getApplicationsList: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  searchTdnSubdivision: PropTypes.instanceOf(Function).isRequired,
  getTaxEffectivityPeriods: PropTypes.instanceOf(Function).isRequired,
  taxEffectivityPeriod: PropTypes.instanceOf(Object).isRequired,
  showData: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  isLoading: _.get(api, "loading", []).indexOf(c.CREATE_TRANSFER_APPLICATION) > -1,
  taxEffectivityPeriod: _.get(api, `${c.GET_TAX_EFFECTIVITY_PERIOD}.list`) || [],
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(SubdivisionModal);
